// Lightweight SVG line chart for assessment score history (0-30 scale, lower = better)
export const ScoreChart = ({ history, maxScore = 30 }) => {
  if (!history || history.length < 2) return null;
  const W = 280, H = 90, PAD = 14;
  const xs = history.map((_, i) => PAD + (i * (W - 2 * PAD)) / (history.length - 1));
  const ys = history.map((h) => H - PAD - ((h.score / maxScore) * (H - 2 * PAD)));
  const path = xs.map((x, i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${ys[i].toFixed(1)}`).join(" ");
  const area = `${path} L${xs[xs.length - 1].toFixed(1)},${H - PAD} L${xs[0].toFixed(1)},${H - PAD} Z`;
  const improving = history[history.length - 1].score < history[0].score;
  const stroke = improving ? "#059669" : "#e11d48";
  const fill = improving ? "rgba(5,150,105,0.08)" : "rgba(225,29,72,0.07)";

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto" role="img"
         aria-label="Score history chart" data-testid="score-chart">
      {[0.25, 0.5, 0.75].map((f) => (
        <line key={f} x1={PAD} x2={W - PAD} y1={PAD + f * (H - 2 * PAD)} y2={PAD + f * (H - 2 * PAD)}
              stroke="#f1f5f9" strokeWidth="1" />
      ))}
      <path d={area} fill={fill} />
      <path d={path} fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      {xs.map((x, i) => (
        <g key={history[i].id || i}>
          <circle cx={x} cy={ys[i]} r="3.5" fill="#fff" stroke={stroke} strokeWidth="2" />
          <text x={x} y={ys[i] - 7} textAnchor="middle" fontSize="9" fontWeight="700" fill="#334155">
            {history[i].score}
          </text>
          <text x={x} y={H - 2} textAnchor="middle" fontSize="7" fill="#94a3b8">
            {String(history[i].created_at || "").slice(5, 10)}
          </text>
        </g>
      ))}
    </svg>
  );
};
